import { FilterDeviceTypeActions, FilterDeviceTypeActionTypes } from './device-type.actions';
import { DeviceTypeCRUDInterface } from '../../../shared/component/filter/filter.class';

export interface FilterDeviceTypeState {
  isLoading: boolean;
  isLoaded: boolean;
  data: DeviceTypeCRUDInterface[];
}

export const initialFilterDeviceTypeState: FilterDeviceTypeState = {
  isLoaded: false,
  isLoading: false,
  data: [],
};

export function filterDeviceTypeReducer(
  state = initialFilterDeviceTypeState,
  action: FilterDeviceTypeActions,
): FilterDeviceTypeState {
  switch (action.type) {
    case FilterDeviceTypeActionTypes.StartLoadFilterDeviceTypes:
      return { ...state, isLoading: true };

    case FilterDeviceTypeActionTypes.FilterDeviceTypesLoaded:
      return { ...state, data: action.data, isLoaded: true, isLoading: false };

    default:
      return state;
  }
}
